import { Theme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

export default function Popover(theme: Theme, containerId: string) {
  return {
    MuiPopover: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z12,
        },
      },
    },
  };
}
